module.exports = __webpack_public_path__ + "img/avatar3.eeeb1bc7.png";